import React, { Fragment, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { GET_ENSENANZAS, ADD_ENSENANZA } from '../../graphql/actions/ensenanza';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput.js';
import Button from '../UI/CustomButtons/Button.js';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const useStyles = makeStyles(sectionAddStyle);
const editorConfiguration = {
  language: 'es',
};

const EnseñanzaAdd = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTipo, setFormTipo] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [addForm, setAddForm] = useState({
    tipo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 10, max: 15 })],
    },
    contenido: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'tipo') {
        if (isValid) setFormTipo('success');
        else setFormTipo('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const redirectToEnsenanzas = (data) => {
    //console.log(data);
    if (data.createEnsenanza) props.history.push('/enseñanzas');
    else console.log('Error adicionando ensenanza.');
  };

  const updateCacheAdd = (cache, { data }) => {
    const { getEnsenanzas } = cache.readQuery({
      query: GET_ENSENANZAS,
      variables: {
        paginate: {
          numEnsenanzas: 30,
          cursor: '',
          sortBy: { field: 'createdAt', order: 'ASC' },
        },
      },
    });

    const nuevaEnsenanza = data?.createEnsenanza;

    if (getEnsenanzas && nuevaEnsenanza) {
      cache.writeQuery({
        query: GET_ENSENANZAS,
        variables: {
          paginate: {
            numEnsenanzas: 30,
            cursor: '',
            sortBy: { field: 'createdAt', order: 'ASC' },
          },
        },
        data: {
          getEnsenanzas: {
            ensenanzas: [nuevaEnsenanza, ...getEnsenanzas?.ensenanzas],
          },
        },
      });
    }
  };

  const [
    createEnsenanza,
    {
      loading: loadingAddEnsenanza,
      error: errorAddEnsenanza,
      data: dataAddEnsenanza,
    },
  ] = useMutation(ADD_ENSENANZA, {
    errorPolicy: 'all',
    update: updateCacheAdd,
    onCompleted: (data) => redirectToEnsenanzas(data),
  });

  const adicionarHandler = (event) => {
    event.preventDefault();

    const ensenanzaData = {};
    for (let i in addForm) {
      ensenanzaData[i] = addForm[i].value;
    }

    createEnsenanza({
      variables: {
        input: {
          tipo: ensenanzaData.tipo,
          resumen: ensenanzaData.resumen,
          contenido: ensenanzaData.contenido,
        },
      },
    });

    //console.log(ensenanzaData);
  };

  let seccionTitulo = (
    <div className={classes.section}>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8}>
          <h2 className={classes.title}>Crear Enseñanza</h2>
        </GridItem>
      </GridContainer>
    </div>
  );

  let seccionButton = (
    <GridContainer>
      <GridItem
        md={4}
        sm={4}
        className={classNames(
          classes.mrAuto,
          classes.mlAuto,
          classes.textCenter
        )}
      >
        <Button type='submit' color='dark' round disabled={!formIsValid}>
          Crear Enseñanza
        </Button>
      </GridItem>
    </GridContainer>
  );

  let seccionFormulario = (
    <div id='formularioAdd'>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <form onSubmit={adicionarHandler}>
            <GridContainer>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Tipo de Enseñanza (*)'
                  success={formTipo === 'success'}
                  error={formTipo === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'tipo');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Resumen (De 10 a 15 palabras)'
                  success={formResumen === 'success'}
                  error={formResumen === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'resumen');
                    },
                    multiline: true,
                    rows: 6,
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <div className={classes.control}>
                  <p className={classes.label}>Contenido</p>
                  <CKEditor
                    //disabled={true}
                    editor={ClassicEditor}
                    data='<br /><br /><br /><br /><br /><br />'
                    config={editorConfiguration}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      //console.log('Editor is ready to use!', editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      inputChangedHandler(data, 'contenido');
                      //console.log({ event, editor, data });
                    }}
                  />
                </div>
              </GridItem>
            </GridContainer>
            {seccionButton}
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
  let showNotification = null;

  if (loadingAddEnsenanza) seccionButton = <Spinner color='gray' />;

  if (errorAddEnsenanza) {
    showNotification = errorAddEnsenanza.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorAddEnsenanza ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataAddEnsenanza && dataAddEnsenanza.createEnsenanza) {
    const { createEnsenanza } = dataAddEnsenanza;
    if (createEnsenanza.success && createEnsenanza.code === '201') {
      showNotification = (
        <Notification
          key={createEnsenanza.code}
          mostrar={createEnsenanza.success ? true : false}
          msg={createEnsenanza.message}
          stt={createEnsenanza.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(EnseñanzaAdd);
